import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';

export function* getPurchaseInvoiceDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.PURCHASE_INVOICE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.PURCHASE_INVOICE_DETAILS_FAILURE });
        return error;
    }
}

export function* getPurchaseTransactionDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest(params.url + '?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest(`${params.url}`));
        }
        yield put({
            type: actions.PURCHASE_TRANSACTION_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.PURCHASE_TRANSACTION_DETAILS_FAILURE });
        return error;
    }
}


export function* getClearDetails() {
    yield put({
        type: actions.CLEAR_PURCHASE_TRANSACTION_DETAILS_SUCCESS,
    });
}


export default function* purchaseTransactionsSaga() {
    yield all([
        takeEvery(actions.PURCHASE_INVOICE_DETAILS_START, getPurchaseInvoiceDetails),
        takeEvery(actions.PURCHASE_TRANSACTION_DETAILS_START, getPurchaseTransactionDetails),
        takeEvery(actions.CLEAR_PURCHASE_TRANSACTION_DETAILS_START, getClearDetails)
    ]);
}